import { createContext, useContext, type Provider } from 'react';

const PostOfficeContextSettledContext = createContext(true);

export const PostOfficeContextSettledProvider: Provider<boolean> =
	PostOfficeContextSettledContext.Provider;

export const usePostOfficeContextSettled = (): boolean =>
	useContext(PostOfficeContextSettledContext);
